<template>
  <div>
    <!-- A global progress bar to indicate that the app is loading something -->
    <v-global-progress-bar namespace="classifier" :flags="progressBarFlags" />
    <!-- Toolbar with the title and sidebar toggle -->
    <v-toolbar />
    <!-- Sidebar with the filters for the items with predictions for the current classification -->
    <v-filters-sidebar />
    <!-- labelers ranking of the current classification -->
    <v-class-ranking-sidebar />
    <!-- Sidebar with the samples of the current classification -->
    <v-samples-sidebar />
    <!-- The content to show -->
    <div style="margin-top: 64px;">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapMutations } = createNamespacedHelpers("classifier");

import VFiltersSidebar from "./components/FiltersSidebar";
import VGlobalProgressBar from "@/components/progress/GlobalProgressBar.vue";
import VSamplesSidebar from "./components/SamplesSidebar";
import VClassRankingSidebar from "./components/ClassRankingSidebar";
import VToolbar from "./components/Toolbar";

export default {
  components: {
    VFiltersSidebar,
    VGlobalProgressBar,
    VClassRankingSidebar,
    VSamplesSidebar,
    VToolbar
  },
  data: () => ({
    progressBarFlags: [
      "loadingCategoriesBySellers",
      "loadingClassifications",
      "loadingCreateClassification",
      "loadingItems",
      "loadingItemsTotal",
      "loadingMergeClassifications",
      "loadingSaveCorrection",
      "loadingSellersWithPredictions"
    ]
  }),
  methods: {
    ...mapMutations(["loadAppSettingsFromStorage"])
  },
  created() {
    this.loadAppSettingsFromStorage();
  }
};
</script>
